export const userKey = 'user'
export const accessTokenKey = 'accessToken'
export const selectedChildKey = 'selectedChild'
export const representativeKey = 'representative'
export const travelLinkKey = 'travelLink'
export const graduationlLinkKey = 'graduationlLink'
